import { Mask } from './Mask';

// TODO: in v9, move styled() from Mask.jsx to here
export var StyledMask = Mask;